/* eslint-disable react-native/no-inline-styles */
import {
  Datepicker,
  Icon,
  IndexPath,
  Input,
  Select,
  SelectItem,
  Text,
} from '@ui-kitten/components';
import moment from 'moment';
import React from 'react';
import {
  Image,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import {getUniqueId} from 'react-native-device-info';
import {ScrollView} from 'react-native-gesture-handler';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getStates} from '../../../apis';
import {starBanner} from '../../../assets/images';
import {
  AUTHENTICATED_ROUTES,
  UN_AUTHENTICATED_ROUTES,
} from '../../../navigation/constants';
import {getAndSetHomeGrades, signUp} from '../../../redux/actions';
import {isWebDesktopView, px, wp} from '../../../utils';
import {fieldUtils} from '../../../utils/fieldUtils';
import AppButton from '../../common/AppButton';
import storage from '@react-native-async-storage/async-storage';

const CalendarIcon = (props) => <Icon {...props} name="calendar" />;

const genderData = ['Male', 'Female'];

const schoolTypes = [
  {title: 'SK', id: 'SK'},
  {title: 'SJK(T)', id: 'SJK(T)'},
  {title: 'SJK(C)', id: 'SJK(C)'},
  {title: 'SMK', id: 'SMK'},
  {title: 'SMJK(C)', id: 'SMJK(C)'},
  {title: 'Private School', id: 'Private School'},
];

const initialFieldsErrors = {
  icNumber: undefined,
  contact: undefined,
  momContact: undefined,
  dadContact: undefined,
  address: undefined,
  postcode: undefined,
  state: undefined,
  city: undefined,
  schoolName: undefined,
};

const isWebDesktop = isWebDesktopView();
class StudentDetails extends React.Component {
  state = {
    ...this.props.route.params.userData,
    gender: new IndexPath(0),
    grade: new IndexPath(0),
    schoolType: new IndexPath(0),
    dob: new Date(new Date().setFullYear(new Date().getFullYear() - 20)),
    icNumber: '',
    contact: '',
    momContact: '',
    dadContact: '',
    address: '',
    postcode: '',
    schoolName: '',
    city: '',
    states: [],
    stateIndex: new IndexPath(0),
    fieldsErrors: {...initialFieldsErrors},
    loading: false,
    errorMessage: '',
  };

  componentDidMount() {
    const {navigation} = this.props;
    const {email_id} = this.state;
    if (!email_id) {
      navigation.push(UN_AUTHENTICATED_ROUTES.signUp.path);
    }

    this.props.getGradeList();
    this.handleGetStates();
  }

  handleGetStates = async () => {
    try {
      const states = await getStates();
      this.setState({states});
    } catch (error) {
      console.log(
        '🚀 ~ file: StudentDetails.js handleGetStates= ~ error',
        error,
      );
    }
  };

  selectDate = (key, value) => {
    this.setState({[key]: value});
  };

  onChangeSelect = (key, index) => {
    this.setState({[key]: index});
  };

  onChange = (key, value) => {
    this.setState({[key]: value});
  };

  onSignIn = () => {
    const {navigation} = this.props;
    navigation.push(UN_AUTHENTICATED_ROUTES.signIn.path);
  };

  checkRequiredFieldsError = () => {
    const {
      icNumber,
      contact,
      momContact,
      dadContact,
      address,
      postcode,
      city,
      states,
      stateIndex,
      schoolName,
    } = this.state;

    const errorText = 'This field should be filled out.';
    const errors = {};

    if (icNumber === '') {
      errors.icNumber = errorText;
    }

    if (contact === '') {
      errors.contact = errorText;
    }

    if (momContact === '') {
      errors.momContact = errorText;
    }

    if (dadContact === '') {
      errors.dadContact = errorText;
    }

    if (address === '') {
      errors.address = errorText;
    }

    if (postcode === '') {
      errors.postcode = errorText;
    }

    if (address === '') {
      errors.address = errorText;
    }

    if (city === '') {
      errors.city = errorText;
    }

    if (schoolName === '') {
      errors.schoolName = errorText;
    }

    if (!states.find((_, rowIndex) => rowIndex === stateIndex.row)) {
      errors.state = errorText;
    }

    return errors;
  };

  checkTextOnlyErrors = () => {
    // only letters and space (\s)
    const regex = /^[A-Za-z\s]+$/;
    const errorText = 'You may use only letters for this Field.';
    const errors = {};

    if (!regex.test(this.state.city)) {
      errors.city = errorText;
    }

    return errors;
  };

  checkNumberOnlyErrors = () => {
    const regex = /^\d+$/;
    const errorText = 'You may use only numbers for this Field.';
    const errors = {};

    if (!regex.test(this.state.contact)) {
      errors.contact = errorText;
    }

    if (!regex.test(this.state.momContact)) {
      errors.momContact = errorText;
    }

    if (!regex.test(this.state.dadContact)) {
      errors.dadContact = errorText;
    }

    if (!regex.test(this.state.postcode)) {
      errors.postcode = errorText;
    }

    return errors;
  };

  checkAlphaNumericOnlyErrors = () => {
    // only letters, numbers and space (\s)
    const regex = /^[a-z0-9\s]+$/i;
    const errorText = 'You may use only letters and numbers for this Field.';
    const errors = {};

    if (!regex.test(this.state.schoolName)) {
      errors.schoolName = errorText;
    }

    return errors;
  };

  isFormValid = () => {
    const requiredErrors = this.checkRequiredFieldsError();
    if (Object.keys(requiredErrors).length) {
      this.setState({fieldsErrors: requiredErrors});
      return false;
    }

    const onlyTextErrors = this.checkTextOnlyErrors();
    if (Object.keys(onlyTextErrors).length) {
      this.setState({fieldsErrors: onlyTextErrors});
      return false;
    }

    const onlyNumberErrors = this.checkNumberOnlyErrors();
    if (Object.keys(onlyNumberErrors).length) {
      this.setState({fieldsErrors: onlyNumberErrors});
      return false;
    }

    const alphaNumericErrors = this.checkAlphaNumericOnlyErrors();
    if (Object.keys(alphaNumericErrors).length) {
      this.setState({fieldsErrors: alphaNumericErrors});
      return false;
    }

    return true;
  };

  onRegister = async () => {
    if (!this.isFormValid()) {
      return;
    }

    const {grade, gender, fullName, email_id} = this.state;
    const {grades} = this.props;

    if (!email_id) {
      this.props.navigation.push(UN_AUTHENTICATED_ROUTES.signUp.path);
    }

    this.onChange('loading', true);

    const kid = {
      name: fullName,
      gender: genderData[gender.row],
      ic_number: this.state.icNumber,
      grade: grades?.[grade.row]?.id || '',
      dob: moment(this.state.dob).format('YYYY-MM-DD'),
    };

    const formData = {
      full_name: fullName,
      email_id: email_id.toLowerCase(),
      password: this.state.password,
      city: this.state.city,
      state: this.state.states.find(
        (_, rowIndex) => rowIndex === this.state.stateIndex.row,
      )?.name,
      contact: this.state.contact,
      mom_contact: this.state.momContact,
      dad_contact: this.state.dadContact,
      address: this.state.address,
      postcode: this.state.postcode,
      user_type: 'student',
      kids: [kid],
      school_name: this.state.schoolName,
      school_type: schoolTypes[this.state.schoolType.row]?.id || '',
    };

    let deviceInfo = {};
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      deviceInfo = {
        deviceId: getUniqueId(),
        deviceType: Platform.OS,
        fcm: await storage.getItem('fcm_token'),
      };
    }
    formData.deviceInfo = deviceInfo;

    this.props.signUp(formData, this.onRegisterSuccess, this.onRegisterFail);
  };

  onRegisterSuccess = () => {
    this.onChange('loading', false);
    this.props.navigation.push(AUTHENTICATED_ROUTES.main.path);
  };

  onRegisterFail = (error) => {
    this.setState({loading: false, errorMessage: error});
  };

  render() {
    const {
      gender,
      grade,
      schoolType,
      dob,
      icNumber,
      contact,
      momContact,
      dadContact,
      address,
      postcode,
      loading,
      errorMessage,
      fieldsErrors,
      city,
      stateIndex,
      states,
      schoolName,
    } = this.state;

    const {grades} = this.props;

    return (
      <View style={styles.container}>
        <ScrollView>
          {isWebDesktop && (
            <Image
              source={starBanner}
              resizeMode="contain"
              style={styles.starImage}
            />
          )}
          <Text
            style={[
              styles.signInLabel,
              isWebDesktop ? {textAlign: 'center'} : undefined,
            ]}>
            {'Register'}
          </Text>
          <View style={styles.formContainer}>
            <Text style={styles.textLabel} status="danger">
              {'* Required information'}
            </Text>
            <Select
              label={fieldUtils.getRequiredLabel('Gender')}
              selectedIndex={gender}
              value={genderData[gender.row]}
              style={styles.inputBox}
              onSelect={(index) => this.onChangeSelect('gender', index)}>
              {genderData?.map((item, index) => {
                return <SelectItem title={item} key={index} />;
              })}
            </Select>
            <Select
              label={fieldUtils.getRequiredLabel('Grade')}
              selectedIndex={grade}
              value={`${grades?.[grade.row]?.type || ''}`}
              style={styles.inputBox}
              onSelect={(index) => this.onChangeSelect('grade', index)}>
              {grades?.map((item, index) => {
                return <SelectItem title={item.type} key={index} />;
              })}
            </Select>
            <Datepicker
              label={fieldUtils.getRequiredLabel('Date of birth')}
              style={styles.inputBox}
              date={dob}
              min={
                new Date(new Date().setFullYear(new Date().getFullYear() - 20))
              }
              max={new Date()}
              onSelect={(nextDate) => this.selectDate('dob', nextDate)}
              accessoryRight={CalendarIcon}
            />
            <Input
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('IC Number')}
              value={icNumber}
              onChangeText={(text) => this.onChange('icNumber', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.icNumber)}
              caption={fieldUtils.getErrorText(fieldsErrors.icNumber)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.icNumber)}
            />
            <Input
              keyboardType="number-pad"
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('Contact Number')}
              autoCompleteType="tel"
              value={contact}
              onChangeText={(text) => this.onChange('contact', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.contact)}
              caption={fieldUtils.getErrorText(fieldsErrors.contact)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.contact)}
            />
            <Input
              keyboardType="number-pad"
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('Mom’s Contact Number')}
              autoCompleteType="tel"
              value={momContact}
              onChangeText={(text) => this.onChange('momContact', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.momContact)}
              caption={fieldUtils.getErrorText(fieldsErrors.momContact)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.momContact)}
            />
            <Input
              keyboardType="number-pad"
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('Dad’s Contact Number')}
              autoCompleteType="tel"
              value={dadContact}
              onChangeText={(text) => this.onChange('dadContact', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.dadContact)}
              caption={fieldUtils.getErrorText(fieldsErrors.dadContact)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.dadContact)}
            />
            <View
              style={[
                styles.inputBox,
                {flexDirection: 'row', alignItems: 'flex-end'},
              ]}>
              <Select
                label={fieldUtils.getRequiredLabel('School name')}
                selectedIndex={schoolType}
                value={schoolTypes[schoolType.row]?.id || ''}
                onSelect={(index) => this.onChangeSelect('schoolType', index)}
                style={{width: wp(35), marginRight: wp(1)}}>
                {schoolTypes.map((item, index) => {
                  return <SelectItem title={item.title} key={index} />;
                })}
              </Select>
            </View>
            <Input
              style={styles.inputBox}
              placeholder="Enter School Name"
              value={schoolName}
              onChangeText={(text) => this.onChange('schoolName', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.schoolName)}
              caption={fieldUtils.getErrorText(fieldsErrors.schoolName)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.schoolName)}
            />
            <Input
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('Address')}
              value={address}
              onChangeText={(text) => this.onChange('address', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.address)}
              caption={fieldUtils.getErrorText(fieldsErrors.address)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.address)}
            />
            <Input
              keyboardType="number-pad"
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('Postcode')}
              value={postcode}
              autoCompleteType="postal-code"
              onChangeText={(text) => this.onChange('postcode', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.postcode)}
              caption={fieldUtils.getErrorText(fieldsErrors.postcode)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.postcode)}
            />
            <Input
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('City')}
              value={city}
              onChangeText={(text) => this.onChange('city', text)}
              status={fieldUtils.getFieldStatus(fieldsErrors.city)}
              caption={fieldUtils.getErrorText(fieldsErrors.city)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.city)}
            />
            <Select
              style={styles.inputBox}
              label={fieldUtils.getRequiredLabel('State')}
              selectedIndex={stateIndex}
              value={
                states.find((_, rowIndex) => rowIndex === stateIndex.row)?.name
              }
              onSelect={(index) => this.setState({stateIndex: index})}
              status={fieldUtils.getFieldStatus(fieldsErrors.state)}
              caption={fieldUtils.getErrorText(fieldsErrors.state)}
              captionIcon={fieldUtils.getErrorIcon(fieldsErrors.state)}>
              {states.map(({id, name}) => (
                <SelectItem title={name} key={id} />
              ))}
            </Select>

            {Boolean(errorMessage) && (
              <Text status="danger">{errorMessage}</Text>
            )}

            <View style={styles.termsAndPPContainer}>
              <Text status="basic">{'By click on next, you accept our'}</Text>
              <TouchableOpacity
                onPress={() => {
                  const {navigation} = this.props;
                  navigation.push(UN_AUTHENTICATED_ROUTES.termsOfServices.path);
                }}>
                <Text status="primary" style={styles.underlineText}>
                  {'Terms of services'}
                </Text>
              </TouchableOpacity>
              <Text status="basic">{'&'}</Text>
              <TouchableOpacity
                onPress={() => {
                  const {navigation} = this.props;
                  navigation.push(UN_AUTHENTICATED_ROUTES.privacyPolicy.path);
                }}>
                <Text status="primary" style={styles.underlineText}>
                  {'Privacy policy'}
                </Text>
              </TouchableOpacity>
              <Text status="basic">{'.'}</Text>
            </View>
            <AppButton
              onPress={this.onRegister}
              style={styles.btnLogin}
              status="primary"
              appearance="filled"
              loader={true}
              loading={loading}
              title="Next"
              size="large"
            />
            <AppButton
              onPress={() => {
                this.props.navigation.goBack();
              }}
              style={styles.btnLogin}
              status="primary"
              appearance="outline"
              title="Back"
              size="large"
            />
            <View style={styles.signInContainer}>
              <Text status="basic">{'Already have an account?'}</Text>
              <TouchableOpacity onPress={this.onSignIn}>
                <Text status="primary" style={styles.underlineText}>
                  {'Login'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFF',
    flex: 1,
    paddingBottom: 24,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  tabContainer: {
    marginBottom: 5,
  },
  signInContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: px(16),
  },
  socialAuthContainer: {
    marginTop: 48,
  },
  btnLogin: {
    marginTop: px(16),
  },
  formContainer: {
    backgroundColor: '#FFF',
    marginTop: 26,
    color: '#000',
  },
  inputBox: {
    marginBottom: 12,
  },
  textLabel: {
    fontWeight: '400',
    fontSize: 14,
    marginBottom: 16,
  },
  signInLabel: {
    marginTop: 28,
    fontWeight: '700',
    fontSize: 24,
    width: '100%',
  },
  signUpButton: {
    flexDirection: 'row-reverse',
    paddingHorizontal: 0,
  },
  socialAuthButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  socialAuthHintText: {
    alignSelf: 'center',
    marginBottom: 16,
  },
  termsAndPPContainer: {
    flexDirection: 'row',
    marginTop: px(20),
    flexWrap: 'wrap',
  },
  underlineText: {
    marginHorizontal: px(5),
  },
  starImage: {
    width: wp(15),
    height: wp(15),
  },
});

const mapStateToProps = (state) => ({
  grades: state.general.signupGrades,
});

const mapDispatchToProps = (dispatch) => ({
  signUp: bindActionCreators(signUp, dispatch),
  getGradeList: bindActionCreators(getAndSetHomeGrades, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentDetails);
